import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
const uuid = require('uuid');

const OrganizationActions = require('../../actions/OrganizationActions');
import WithOrganizationIntegrationTags from '../DataHOCs/WithOrganizationIntegrationTags';
import WithOrganizationTagImportChanges from '../DataHOCs/WithOrganizationTagImportChanges';
import AccessibleIcon from '../common/AccessibleIcon';
import ErrorBox from '../common/ErrorBox';

const propTypes = {
    className: PropTypes.string,
    orgId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    orgIntegrationTags: PropTypes.array.isRequired,
    organizationStoreAction: PropTypes.object.isRequired,
    orgTagImportChanges: PropTypes.shape({
        tagsToAdd: PropTypes.array,
        tagsToDelete: PropTypes.array,
        tagsToUpdate: PropTypes.array,
        existingTagsHash: PropTypes.string.isRequired,
    }).isRequired,
};

const defaultProps = {
    className: '',
};

class OrgIntegrationTagImportChanges extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            confirmActionId: null,
            error: null,
        };

        this.onCancelChanges = this.onCancelChanges.bind(this);
        this.onConfirmChanges = this.onConfirmChanges.bind(this);
    }

    componentDidUpdate() {
        if (this.props.organizationStoreAction.id === this.state.confirmActionId) {
            this.setState({
                confirmActionId: null,
                error: this.props.organizationStoreAction.error || null,
            });
        }
    }

    onCancelChanges() {
        if (!!this.state.confirmActionId) return;

        this.setState({ error: null }, () => {
            OrganizationActions.clearImportIntegrationTagChanges(uuid.v4(), { orgId: this.props.orgId });
        })
    }

    onConfirmChanges() {
        const confirmActionId = uuid.v4();
        this.setState({ confirmActionId: confirmActionId }, () => {
            OrganizationActions.confirmImportIntegrationTagChanges(
                confirmActionId,
                { 
                    orgId: this.props.orgId,
                    operations: this.props.orgTagImportChanges,
                }
            );
        });
    }

    render() {
        let noChanges = (
            !this.props.orgTagImportChanges 
            || (
                !this.props.orgTagImportChanges.tagsToAdd.length
                // && !this.props.orgTagImportChanges.tagsToDelete.length
                && !this.props.orgTagImportChanges.tagsToUpdate.length
            )
        );
        let updateExistingError = false; // unable to find existing tag in store that will updated during operation

        return (
            <div className={this.props.className}>
                {noChanges ?
                    <div className="font-style-italic font-weight-bold text-centered margin-bottom-lg">
                        No changes detected in imported file
                    </div>
                    :
                    <div>
                        <ErrorBox error={this.state.error} />
                        <div className="margin-bottom-xl">
                            <div className="sm-heading margin-bottom-lg">Added Tags</div>
                            <div className="sub-heading">The following tags are new and will be added:</div>
                            {this.props.orgTagImportChanges.tagsToAdd.map((tagToAdd) =>
                                <div className="tagBlock margin-bottom-md" key={`add-${tagToAdd.tag}`}>
                                    <div className="tagBlock__icon success-text">
                                        <AccessibleIcon className="fa fa-plus" label="Adding" />
                                    </div>
                                    <div className="tagBlock_info">
                                        <div className="tagBlock__attr">Name: <span className="font-weight-bold">{tagToAdd.tag}</span></div>
                                        <div className="tagBlock__attr">Description: <span className='font-style-italic'>{tagToAdd.description}</span></div>
                                    </div>
                                </div>
                            )}
                            {!this.props.orgTagImportChanges.tagsToAdd.length &&
                                <div className="font-style-italic font-weight-bold font-size-14px">
                                    None (No changes detected in imported file)
                                </div>
                            }
                        </div>
                        {/*
                        <div className="margin-bottom-xl">
                            <div className="sm-heading margin-bottom-lg">Deleted Tags</div>
                            <div className="sub-heading">The following tags are not present in the imported file and will be deleted:</div>
                            {this.props.orgTagImportChanges.tagsToDelete.map((tagToDelete) =>
                                <div className="tagBlock margin-bottom-md" key={`delete-${tagToDelete.id}`}>
                                    <div className="tagBlock__icon danger-text">
                                         <AccessibleIcon className="fa fa-trash" label="Deleting" />
                                    </div>
                                    <div className="tagBlock__info">
                                        <div className="tagBlock__attr">Name: <span className="font-weight-bold">{tagToDelete.tag}</span></div>
                                        <div className="tagBlock__attr">Description: <span className='font-style-italic'>{tagToDelete.description}</span></div>
                                    </div>
                                </div>
                            )}
                            {!this.props.orgTagImportChanges.tagsToDelete.length &&
                                <div className="font-style-italic font-weight-bold font-size-14px">
                                    None (No changes detected in imported file)
                                </div>
                            }
                        </div>
                        */}
                        <div className="margin-bottom-xl">
                            <div className="sm-heading margin-bottom-lg">Updated Tags</div>
                            <div className="sub-heading">The following tags have changes in the imported file and will be updated accordingly:</div>
                            {this.props.orgTagImportChanges.tagsToUpdate.map((tagToUpdate) => {
                                const existingTag = this.props.orgIntegrationTags.find(t => t.id === tagToUpdate.id);
                                if (!existingTag) {
                                    updateExistingError = true;
                                    return (
                                        <div key={`update-${tagToUpdate.id}`}>
                                            Error matching tag update to an existing tag.
                                        </div>
                                    );
                                }

                                return (
                                    <div className="tagBlock margin-bottom-md" key={`update-${tagToUpdate.id}`}>
                                        <div className="tagBlock__icon">
                                            <AccessibleIcon className="fa fa-refresh" label="Updating" />
                                        </div>
                                        <div className="tagBlock__info">
                                            <div className="tagBlock__attr">Name: <span className="font-weight-bold">{tagToUpdate.tag}</span></div>
                                            <div className="tagBlock__attr">New Description: <span className='font-style-italic'>{tagToUpdate.description}</span></div>
                                            <div className="tagBlock__attr">Old Description: <span className='font-style-italic'>{existingTag.description}</span></div>
                                        </div>
                                    </div>
                                );
                            })}
                            {!this.props.orgTagImportChanges.tagsToUpdate.length &&
                                <div className="font-style-italic font-weight-bold font-size-14px">
                                    None (No changes detected in imported file)
                                </div>
                            }
                        </div>
                    </div>
                }
                <div className="fr">
                    <Button 
                        variant='primary'
                        className="margin-right-md"
                        disabled={!!this.state.confirmActionId}
                        onClick={this.onCancelChanges}
                    >
                            Cancel
                    </Button>
                    <Button
                        variant='danger'
                        disabled={noChanges || updateExistingError || !!this.state.confirmActionId}
                        onClick={this.onConfirmChanges}
                    >
                        Confirm Changes
                    </Button>
                </div>
                <div className="float-clear" />
            </div>
        );
    }
}

OrgIntegrationTagImportChanges.propTypes = propTypes;
OrgIntegrationTagImportChanges.defaultProps = defaultProps;

export default WithOrganizationIntegrationTags(WithOrganizationTagImportChanges(OrgIntegrationTagImportChanges));